document.addEventListener('DOMContentLoaded', function() {
    const Options = {
      slidesPerView: 'auto',
      spaceBetween: 20,
      grabCursor: true,
      freeMode: true,
      enabled: true,
      loop: false,
      breakpoints: {
        769: {
          spaceBetween: 30,
        },
        1366: {
          spaceBetween: 50,
        }
      },
    };
  
    const Feature = new Swiper('#Product .swiper', Options);

  });